<template>
  <b-modal
    size="md"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <LgFinderPageUnidadeAdministrativa
          v-model="form.unidadeAdministrativa"
          label="Unidade Administrativa:"
          :podeApagarDepartamento="false"
          required
          @onselect="handleSelectUnidadeAdministrativa"
        />
      </b-form-group>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>
  </b-modal>
</template>

<script>
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";

export default {
  components: {
    LgFinderPageUnidadeAdministrativa,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      form: {
        unidadeAdministrativa: null,
      },
    };
  },
  methods: {
    handleSelectUnidadeAdministrativa(unidade) {
      this.form.unidadeAdministrativa = unidade;
    },
    async salvar() {
      if (!this.form.unidadeAdministrativa) {
        this.$bvToast.toast("Selecione uma Unidade Administrativa", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const payload = {
        id: this.configuracao.id,
        valorPropriedade: this.form.unidadeAdministrativa.id.toString(),
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit("salvo");
        await Swal.fire({
          title: "Sucesso",
          text: "Configuração salva com sucesso!",
          icon: "success",
          confirmButtonText: "OK",
        });
      } catch (error) {
        this.$bvToast.toast("Erro ao salvar configuração", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit("close");
    },
    carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        this.form.unidadeAdministrativa = {
          id: parseInt(this.configuracao.valorPropriedade),
          descricao: this.configuracao.valorPropriedadeLabel,
        };
      }
    },
  },
  mounted() {    
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
